// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Label = require("../common/Components/Label.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var Tooltip = require("../../reason/common/Tooltip.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var DateIcon = require("../common/Components/DateIcon.bs.js");
var DateFns = require("date-fns");
var AgentInfo = require("../common/Agent/AgentInfo.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var FeatureGate = require("../../reason/subscription/FeatureGate.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ShowingsUtils = require("../common/ShowingsUtils.bs.js");
var TailwindMerge = require("tailwind-merge");
var PropertyMlsLabel = require("../property/PropertyMlsLabel.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ShowingsPageRelayShowingsByDay_showing_graphql = require("../../__generated__/ShowingsPageRelayShowingsByDay_showing_graphql.bs.js");
var ShowingsPageRelayShowingsByDay_showings_graphql = require("../../__generated__/ShowingsPageRelayShowingsByDay_showings_graphql.bs.js");

var convertFragment = ShowingsPageRelayShowingsByDay_showings_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ShowingsPageRelayShowingsByDay_showings_graphql.node, convertFragment, fRef);
}

var ShowingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = ShowingsPageRelayShowingsByDay_showing_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ShowingsPageRelayShowingsByDay_showing_graphql.node, convertFragment$1, fRef);
}

var ShowingFragment_showingTypeV5_decode = ShowingsPageRelayShowingsByDay_showing_graphql.Utils.showingTypeV5_decode;

var ShowingFragment_showingTypeV5_fromString = ShowingsPageRelayShowingsByDay_showing_graphql.Utils.showingTypeV5_fromString;

var ShowingFragment_visibilityReason_decode = ShowingsPageRelayShowingsByDay_showing_graphql.Utils.visibilityReason_decode;

var ShowingFragment_visibilityReason_fromString = ShowingsPageRelayShowingsByDay_showing_graphql.Utils.visibilityReason_fromString;

var ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  visibilityReason_decode: ShowingFragment_visibilityReason_decode,
  visibilityReason_fromString: ShowingFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ShowingsPageRelayShowingsByDay$Showing(props) {
  var showing = use$1(props.showing);
  var chapterTimezone = UserSession.useChapterTimezone();
  var match = showing.type_;
  var badgeText;
  if (match === "BUYERS_WELCOME" || match === "AGENTS_ONLY" || match === "TAN_ONLY") {
    switch (match) {
      case "AGENTS_ONLY" :
          badgeText = "Agents only";
          break;
      case "BUYERS_WELCOME" :
          badgeText = "Buyers welcome";
          break;
      case "TAN_ONLY" :
          badgeText = "TAN only";
          break;
      
    }
  } else {
    badgeText = undefined;
  }
  var alsoShowingOn = Core__Array.filterMap(Core__Option.getOr(Core__Option.map(showing.property.showings, (function (v) {
                  return v.edges;
                })), []), (function (v) {
          if (v === undefined) {
            return ;
          }
          var node = v.node;
          if (node.id !== showing.id && UTCDate.isAfter(Scalars.DateTime.toUTC(node.startDate), UTCDate.now())) {
            return node;
          }
          
        }));
  var showPropertyDetails = UserSession.useShouldShowPropertyDetails(Core__Option.flatMap(showing.property.agentV2, (function (a) {
              if (a.__typename === "VisibleForSalePropertyAgent") {
                return a.agent.id;
              }
              
            })));
  var match$1 = showing.property.propertyLocation;
  var tmp;
  if (showPropertyDetails) {
    if (match$1 !== undefined) {
      switch (match$1.__typename) {
        case "PropertyLocationWithHiddenAddress" :
            var locationDisplay = match$1.locationDisplay;
            tmp = locationDisplay !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: locationDisplay,
                            className: "text-lg md:text-xl"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Icon__Jsx3.make, {
                                          icon: "Lock",
                                          className: "text-gray-600 mr-1",
                                          size: 16
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: "Contact agent for address"
                                        })
                                  ],
                                  className: "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
                                }),
                            className: "text-gray-600 text-lg"
                          })
                    ]
                  }) : null;
            break;
        case "PropertyLocationWithVisibleAddress" :
            var address = match$1.address;
            if (address !== undefined) {
              var locationDisplay$1 = match$1.locationDisplay;
              if (locationDisplay$1 !== undefined) {
                var visibilityRule = match$1.visibilityRule;
                if (visibilityRule !== undefined) {
                  var exit = 0;
                  if (visibilityRule === "VISIBLE_TO_ALL" || visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF") {
                    switch (visibilityRule) {
                      case "VISIBLE_TO_ALL" :
                          tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {
                                children: Caml_option.some(JsxRuntime.jsx("div", {
                                          children: address + ", " + locationDisplay$1,
                                          className: "text-lg md:text-xl"
                                        }))
                              });
                          break;
                      case "VISIBLE_TO_ACCOUNT_MEMBER" :
                      case "VISIBLE_TO_TAN_STAFF" :
                          exit = 1;
                          break;
                      
                    }
                  } else {
                    tmp = null;
                  }
                  if (exit === 1) {
                    tmp = JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: locationDisplay$1,
                                  className: "text-lg md:text-xl"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Tooltip.make, {
                                        ariaLabel: address,
                                        label: address + " (only visible to " + (
                                          visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" ? "you" : "TAN staff"
                                        ) + ")",
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Icon__Jsx3.make, {
                                                      icon: "Lock",
                                                      className: "text-gray-600 mr-1",
                                                      size: 16
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: "Hidden address"
                                                    })
                                              ],
                                              className: "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
                                            })
                                      }),
                                  className: "text-gray-600 text-lg"
                                })
                          ],
                          className: "flex flex-col md:flex-row"
                        });
                  }
                  
                } else {
                  tmp = null;
                }
              } else {
                tmp = null;
              }
            } else {
              tmp = null;
            }
            break;
        case "__unselected" :
            tmp = null;
            break;
        
      }
    } else {
      tmp = null;
    }
  } else if (match$1 !== undefined) {
    var exit$1 = 0;
    var locationDisplay$2;
    switch (match$1.__typename) {
      case "PropertyLocationWithHiddenAddress" :
          var locationDisplay$3 = match$1.locationDisplay;
          if (locationDisplay$3 !== undefined) {
            locationDisplay$2 = locationDisplay$3;
            exit$1 = 1;
          } else {
            tmp = null;
          }
          break;
      case "PropertyLocationWithVisibleAddress" :
          var locationDisplay$4 = match$1.locationDisplay;
          if (locationDisplay$4 !== undefined) {
            locationDisplay$2 = locationDisplay$4;
            exit$1 = 1;
          } else {
            tmp = null;
          }
          break;
      case "__unselected" :
          tmp = null;
          break;
      
    }
    if (exit$1 === 1) {
      tmp = JsxRuntime.jsx("div", {
            children: locationDisplay$2,
            className: "text-xl font-medium text-gray-800",
            title: locationDisplay$2
          });
    }
    
  } else {
    tmp = null;
  }
  var notes = showing.notes;
  var match$2 = showing.property.agentV2;
  var tmp$1;
  tmp$1 = match$2 !== undefined && match$2.__typename === "VisibleForSalePropertyAgent" ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(AgentInfo.make, {
                agent: match$2.agent.fragmentRefs
              })
        }) : null;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                badgeText !== undefined ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Label.Neutral.make, {
                                              text: badgeText
                                            }),
                                        className: "mb-1"
                                      }) : null,
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(PropertyMlsLabel.make, {
                                            property: showing.property.fragmentRefs
                                          }),
                                      className: "block md:hidden"
                                    })
                              ],
                              className: "flex flex-row gap-3"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                                    href: "/properties/" + showing.property.id,
                                    className: "text-gray-900",
                                    children: Caml_option.some(JsxRuntime.jsxs("div", {
                                              children: [
                                                tmp,
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(PropertyMlsLabel.make, {
                                                            property: showing.property.fragmentRefs
                                                          }),
                                                      className: "hidden md:block"
                                                    })
                                              ],
                                              className: "flex flex-row space-x-4 text-3xl items-center"
                                            }))
                                  }),
                              className: "flex flex-row space-x-4 relative"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: ShowingsUtils.formatShowingTimes(showing.startDateV2, showing.endDateV2),
                                    className: "text-md md:text-lg text-gray-700"
                                  }),
                              className: "flex flex-row space-x-2 text-left"
                            })
                      ],
                      className: "flex flex-col gap-2 md:gap-0"
                    }),
                JsxRuntime.jsx(FeatureGate.PropertyDetailsGate.make, {
                      children: notes !== undefined ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: notes,
                                    className: "whitespace-pre-line text-gray-700"
                                  })
                            }) : null
                    }),
                alsoShowingOn.length !== 0 ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Also showing on: ",
                                className: "text-left text-gray-700"
                              }),
                          JsxRuntime.jsx("div", {
                                children: alsoShowingOn.map(function (showing, i) {
                                      var match = (alsoShowingOn.length - 1 | 0) - i | 0;
                                      return JsxRuntime.jsxs("span", {
                                                  children: [
                                                    JsxRuntime.jsx(ButtonsV5.Link.make, {
                                                          href: "/properties/" + (showing.property.id + "#showings"),
                                                          children: Caml_option.some(DateFns.format(UTCDate.toZonedDate(Scalars.DateTime.toUTC(showing.startDate), chapterTimezone), "LLL d"))
                                                        }),
                                                    match !== 0 ? (
                                                        match !== 1 ? JsxRuntime.jsx("span", {
                                                                children: ", "
                                                              }) : JsxRuntime.jsx("span", {
                                                                children: " and "
                                                              })
                                                      ) : null
                                                  ]
                                                }, showing.id);
                                    })
                              })
                        ],
                        className: "flex flex-row space-x-1"
                      }) : null,
                tmp$1
              ],
              className: "bg-white flex flex-col gap-4 items-start"
            });
}

var Showing = {
  ShowingFragment: ShowingFragment,
  make: ShowingsPageRelayShowingsByDay$Showing
};

function ShowingsPageRelayShowingsByDay(props) {
  var date = props.date;
  console.log(date);
  var showings = use(props.showings);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(DateIcon.FromPlainDate.make, {
                                  date: date
                                }),
                            className: "mr-7 mb-5"
                          }),
                      JsxRuntime.jsx("div", {
                            children: showings.map(function (showing, index) {
                                  return JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(ShowingsPageRelayShowingsByDay$Showing, {
                                                    showing: showing.fragmentRefs
                                                  }),
                                              className: TailwindMerge.twMerge([
                                                    "pt-8",
                                                    index === 0 ? "pt-0" : ""
                                                  ])
                                            }, showing.id);
                                }),
                            className: "grow divide-y divide-gray-200 flex flex-col gap-8"
                          })
                    ],
                    className: "flex flex-row items-stretch"
                  }),
              className: "border p-5 rounded"
            });
}

var Card;

var make = ShowingsPageRelayShowingsByDay;

exports.Card = Card;
exports.ShowingsFragment = ShowingsFragment;
exports.Showing = Showing;
exports.make = make;
/* Label Not a pure module */
